import View, { FitOptions } from 'ol/View';
import { Coordinate } from 'ol/coordinate';
import { MAP_FIT_MAX_ZOOM } from '../../util/constants';
import { buffer, Extent, getHeight, getWidth } from 'ol/extent';

const DEFAULT_FIT_OPTIONS: FitOptions = {
  padding: [10, 10, 10, 10],
  duration: 100,
  maxZoom: MAP_FIT_MAX_ZOOM,
};

const HEATMAP_FIT_PADDING = [50, 50, 50, 50] as const;
/** Buffer around a single heatmap point so view.fit has a non-zero area (EPSG:3857 metres). */
const HEATMAP_SINGLE_POINT_BUFFER_METRES = 500;

export const normalizeHeatmapFitExtent = (extent: Extent): Extent => {
  if (getWidth(extent) === 0 || getHeight(extent) === 0) {
    return buffer(extent, HEATMAP_SINGLE_POINT_BUFFER_METRES);
  }
  return extent;
};

export const panTo = (view: View, to: Coordinate) =>
  view.animate({
    center: to,
    duration: 300,
  });

export const getCoordinateDifference = (from: number[], to: number[]): number =>
  Math.abs(from[0] - to[0]) + Math.abs(from[1] - to[1]);

export const getExtentDifference = (from: Extent, to: Extent): number =>
  Math.abs(from[0] - to[0]) +
  Math.abs(from[1] - to[1]) +
  Math.abs(from[2] - to[2]) +
  Math.abs(from[3] - to[3]);

export const fitToExtent = (view: View, extent: Extent, options?: FitOptions) =>
  view.fit(extent, {
    ...DEFAULT_FIT_OPTIONS,
    ...options,
  });

export const fitHeatMapExtent = (view: View, extent: Extent) =>
  fitToExtent(view, normalizeHeatmapFitExtent(extent), {
    padding: [...HEATMAP_FIT_PADDING],
    duration: 0,
  });
